<template>
  <div>
    {{ column.title }}
  </div>
</template>

<script setup lang="ts">
import type { TableColumn } from "@/types/table";
import type { LabelTemplateTableData } from "@/stores/labelTemplate/labelTemplateStore";

defineProps<{
  column: TableColumn<LabelTemplateTableData>;
  isAdminAccount?: boolean;
}>();
</script>

<style scoped lang="scss"></style>
